import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName = 'todo'

export let ApproveTypeEnum = {
  /**
   * 工资变更审核
   */
  WAGES_APPROVE: 1,
  /**
   * 佣金提取审批
   */
  COMMIONTION_APPROVE: 2,
  /**
   * 报销审批
   */
  EXPENSE_APPROVE: 3,
  /**
   * 请假审批
   */
  LEAVE_APPROVE: 4
}

export function todoList(parameter) {
  console.log('params:', parameter)
  return axios({
    url: `/ws/${moduleName}/todoList`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function history(parameter) {
  console.log('params:', parameter)
  return axios({
    url: `/ws/${moduleName}/history`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function approve(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/approve`,
    method: 'post',
    data: parameter
  })
}

export function approveBatch(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/approveBatch`,
    method: 'post',
    data: parameter
  })
}

export function queryHistoryComments(actInstanceId) {
  console.log('actInstanceId:', actInstanceId)
  return axios({
    url: `/ws/${moduleName}/queryHistoryComments/${actInstanceId}`,
    method: 'get',
  })
}

export function getProcessStep(taskId) {
  console.log('taskId:', taskId)
  return axios({
    url: `/ws/${moduleName}/getProcessStep/${taskId}`,
    method: 'get',
  })
}


export function getProcessStepCancel(actInstanceId) {
  console.log('actInstanceId:', actInstanceId)
  return axios({
    url: `/ws/${moduleName}/getProcessStepCancel/${actInstanceId}`,
    method: 'get',
  })
}

export function getProcessInfo(businessId,type,createrId) {
  console.log('businessId:', businessId)
  console.log('type:', type)
  console.log('createrId:', createrId)
  return axios({
    url: `/ws/${moduleName}/getProcessInfo/${businessId}/${type}/${createrId}`,
    method: 'get',
  })
}




export default {
  todoList,
  history,
  queryHistoryComments,
  getProcessStepCancel,
  getProcessStep,
  approve,
  approveBatch,
  getProcessInfo,
  ApproveTypeEnum
}